import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={37}
            height={36}
            viewBox="0 0 37 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.92 9.59A9.485 9.485 0 0110.407.105h8.278c9.81 0 17.763 7.953 17.763 17.764 0 9.81-7.953 17.763-17.763 17.763-9.81 0-17.763-7.953-17.763-17.763V9.59z"
                fill={theme["#B4E3E1"]}
            />
            <path
                d="M23.546 10.499c-.389 0-.773.086-1.125.254v-.629a2.625 2.625 0 00-5.123-.806 2.625 2.625 0 00-3.877 2.306v6l-.358-.575a2.625 2.625 0 00-4.556 2.608c1.5 3.166 2.712 5.412 4.099 6.815 1.4 1.421 2.99 2.027 5.315 2.027a8.259 8.259 0 008.25-8.25v-7.125a2.625 2.625 0 00-2.625-2.625zm1.125 9.75a6.757 6.757 0 01-6.75 6.75c-1.91 0-3.141-.457-4.25-1.58-1.24-1.257-2.381-3.389-3.822-6.428a.606.606 0 00-.028-.055 1.125 1.125 0 111.963-1.103l1.75 2.813a.749.749 0 001.387-.397v-8.625a1.125 1.125 0 112.25 0v5.625a.75.75 0 101.5 0v-7.125a1.125 1.125 0 112.25 0v7.125a.75.75 0 101.5 0v-4.125a1.125 1.125 0 112.25 0v7.125z"
                fill={theme["#0D968F"]}
            />
        </svg>
    )
}
  
  export default SvgComponent